module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a",
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/acknowledgments"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-h1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART I")]), _vm._v(". THE VIEW FROM LONDON")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-h2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER ONE")]), _vm._v(". “The Tyrant.” George III")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "toc-h2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER TWO")]), _vm._v(". The Prime Minister. Lord North.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-h1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART II")]), _vm._v(". VICTORY AND DEFEAT IN THE NORTH (1776–1778)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-h2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER THREE")]), _vm._v(". The Peace Commissioners? The Howe Brothers.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-h2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER FOUR")]), _vm._v(". “The Old Gamester.” John Burgoyne.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-h2"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER FIVE")]), _vm._v(". “The Achilles of the American War.” Lord George Germain.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-h1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART III")]), _vm._v(". VICTORY AND DEFEAT IN THE SOUTH (1778–1781)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-h2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER SIX.")]), _vm._v(" “The Scapegoat.” Sir Henry Clinton.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-h2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER SEVEN")]), _vm._v(". “Bagging the Fox.” Charles, Earl Cornwallis.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-h1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART IV")]), _vm._v(". VICTORY AGAINST FRANCE AND SPAIN (1782)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-h2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER EIGHT")]), _vm._v(". “Saint George.” Sir George Rodney.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-h2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER NINE")]), _vm._v(". “Jemmy Twitcher.” The Earl of Sandwich.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-backt"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-back"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-back"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-back"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-backt"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05fig1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Color plates follow page")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 75
// module chunks = 0